module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"selectTheParts":"Seleccione las partes","cancel":"Cancelar","save":"Guardar"},"en":{"selectTheParts":"Select the parts","cancel":"Cancel","save":"Save"}}')
  delete Component.options._Ctor
}
